import { gql } from '@apollo/client'

export const DELETE_INVESTORS = gql`
  mutation deleteInvestors($ids: [ID!]) {
    deleteInvestors(ids: $ids) {
      count
    }
  }
`

export const COPY_INVESTOR = gql`
  mutation copyInvestor($investorId: String!, $portfolioId: String!) {
    copyInvestor(investorId: $investorId, portfolioId: $portfolioId) {
      _id
      orgId
      portfolioId
      realeflowData
      createdAt
    }
  }
`

export const UPDATE_INVESTOR = gql`
  mutation updateInvestors(
    $ids: [ID!]!
    $investorInput: InvestorInput!
  ) {
    updateInvestors(ids: $ids, investorInput: $investorInput) {
      _id
      orgId
      portfolioId
      realeflowData
      createdAt
    }
  }
`
